import { userManager } from '../config/oidcConfig';

/**
 * Custom fetch function that automatically adds the authentication token
 * @param url The URL to fetch
 * @param options Fetch options
 * @returns Promise with the fetch response
 */
export const authenticatedFetch = async (url: string, options: RequestInit = {}) => {
  const user = await userManager.getUser();
  const token = user?.access_token;

  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  // Return the response as is for non-JSON responses
  return response;
};

/**
 * API client configuration for React Query
 */
export const apiClient = {
  get: (url: string) => authenticatedFetch(url),
  post: (url: string, data: any) =>
    authenticatedFetch(url, {
      method: 'POST',
      body: data ? JSON.stringify(data) : undefined,
    }),
  put: (url: string, data: any) =>
    authenticatedFetch(url, {
      method: 'PUT',
      body: data ? JSON.stringify(data) : undefined,
    }),
  delete: (url: string) =>
    authenticatedFetch(url, {
      method: 'DELETE',
    }),
};
